import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Rooms from './components/Rooms';
import Safari from './components/Safari';
import Facilities from './components/Facilities';
import Gallery from './components/Gallery';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import BookingWidget from './components/BookingWidget';
import './App.css';

function HomePage() {
  return (
    <>
      <Hero />
      <About />
      <Rooms />
      <Safari />
      <Facilities />
      <Gallery />
      <Testimonials />
      <Contact />
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="app">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
        </Routes>
        <Footer />
        <BookingWidget />
      </div>
    </Router>
  );
}

export default App;